// IMPORTANT! if some of these schema will be updated please sync them with json-type-checker/src/HeaderNew/HeaderFull/schema.ts

import { Infer, array, enums, nullable, object, string } from "superstruct";
import { cfJsonAnchorSchema } from "components/Anchor/schema";
import {
  headerLogoSchema,
  translationsSchema,
} from "components/HeaderNew/schema";

const submenuGroupItemSchema = object({
  label: string(),
  description: nullable(string()),
  ...cfJsonAnchorSchema.schema,
  icon: nullable(string()),
  alt: nullable(string()),
});

// the schema of the list of items the second level of menu (title + single voices)
const submenuGroupSchema = object({
  title: nullable(string()),
  items: array(submenuGroupItemSchema),
});

// the schema of the sidebar inside the dropdown when clicking a voice inside the second level menu
const submenuSidebarSchema = nullable(
  object({
    title: string(),
    // other info about the active voice of the second level menu
    text: string(),
    image: nullable(
      object({
        // the src of the image
        src: string(),
        alt: string(),
      }),
    ),
    ctaImage: nullable(cfJsonAnchorSchema),
  }),
);

// the schema of the second level menu
const headerSubmenuSchema = object({
  label: string(),
  ...cfJsonAnchorSchema.schema,
  // the sidebar that appears when clicking on the second level menu
  sidebarMenu: submenuSidebarSchema,
  // this is the list of voices inside the dropdown when clicking a voice into the second level menu
  groups: array(submenuGroupSchema),
  // a label that redirect to the page with full list of items
  showAllCtaLabel: nullable(
    object({
      labelDesktop: string(),
      labelMobile: string(),
    }),
  ),
});

// the schema of first level menu (the blue one)
const headerMenuItemSchema = object({
  label: string(),
  ...cfJsonAnchorSchema.schema,
  // the collection of second level menu inside the first level menu (the oval one)
  submenu: array(headerSubmenuSchema),
});

const privateAreaSchema = array(
  object({
    ctaLabel: string(),
    ctaAnchor: cfJsonAnchorSchema,
    ctaTheme: enums([
      "primary",
      "secondary",
      "ghost",
      "primary-inverse",
      "secondary-inverse",
      "ghost-inverse",
    ]),
  }),
);

const headerSettingsSchema = object({
  logo: headerLogoSchema,
  translations: translationsSchema,
  privateArea: privateAreaSchema,
  search: object({
    slug: string(),
    templateSlug: string(),
    text: string(),
  }),
});

const headerMenuSchema = object({
  __typename: string(),
  contentful_id: string(),
  menu: array(headerMenuItemSchema),
  menuIdentifiers: object({
    __typename: string(),
    contentful_id: string(),
  }),
  settings: headerSettingsSchema,
});

export { headerMenuSchema };

export type HeaderMenuSchema = Infer<typeof headerMenuSchema>;

export type HeaderMenuItemSchema = Infer<typeof headerMenuItemSchema>;

export type HeaderSubmenuSchema = Infer<typeof headerSubmenuSchema>;

export type HeaderSubmenuSidebarSchema = Infer<typeof submenuSidebarSchema>;

export type HeaderSubmenuGroupSchema = Infer<typeof submenuGroupSchema>;

export type PrivateAreaSchema = Infer<typeof privateAreaSchema>;

export type HeaderMenuSettingsSchema = Infer<typeof headerSettingsSchema>;

export type SubmenuGroupItemSchema = Infer<typeof submenuGroupItemSchema>;

export type CfHeaderMenuData = {
  dataJson: HeaderMenuSchema;
};

export type CfHeaderMenuProps = {
  menu: CfHeaderMenuData;
};
